import { capitalize } from 'lodash/fp';
import { components as ReactSelectComponents, OptionProps } from 'react-select';

import { Option } from 'dashboard/components/CaseDataManagerSchemaSelect/utils';
import { OptionType } from 'dashboard/components/ReactSelect';
import { getJsonSchemaType } from 'dashboard/lib/workflows';
import { Paragraph } from 'design-system/components/Text';

type SelectOptionType = OptionType & Pick<Option, 'schema' | 'property'>;

const SelectOption = (props: OptionProps<SelectOptionType>) => {
  const selectionText = `Type: ${capitalize(getJsonSchemaType(props.data.schema) || 'Unknown')}`;
  return (
    <ReactSelectComponents.Option {...props} innerProps={{ ...props.innerProps }}>
      <div>
        <Paragraph style={{ lineBreak: 'anywhere' }}>{props.data.property}</Paragraph>
        <Paragraph size='sm'>{selectionText}</Paragraph>
      </div>
    </ReactSelectComponents.Option>
  );
};

export default SelectOption;
